module.exports = __webpack_public_path__ + "media/images/athletes/538-4b42b4429ed7d2680afb15727aa9ee06.png";